/**
 * Resolve after the browser has had two animation frames to commit and paint an intermediate state.
 */
export const yieldToNextPaint = (): Promise<void> =>
    new Promise((resolve) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => resolve());
        });
    });
